import { Keyframe } from ".";
import { css } from "styled-components";

const Duration = Object.freeze({
  normal: "2s",
});

export default function (
  keyframe: keyof typeof Keyframe,
  duration: keyof typeof Duration = "normal"
) {
  return css`
    animation: ${Keyframe[keyframe]} ${Duration[duration]} linear infinite;
  `;
}
